import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faRoute } from '@fortawesome/free-solid-svg-icons';
import data from './data';
import Card, { CardImage, CardBody, CardTitle, CardDescription, CardFooter } from '../../components/Card';
import './portfolio.css';

const Portfolio = () => {
  const [projects, setProjects] = useState(data);
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = data.map((item) => item.category);
  const uniqueCategories = ['all', ...new Set(categories)];

  const filterProjectsHandler = (category) => {
    setActiveCategory(category);
    if (category === 'all') {
      setProjects(data);
      return;
    }
    const filterProjects = data.filter((project) => project.category === category);
    setProjects(filterProjects);
  };

  const handleDirectionsClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="locations section section--muted" id="portfolio">
      <div className="container">
        {/* Section Header */}
        <div className="locations__header" data-aos="fade-up">
          <h2 className="locations__title">Lokasi iTech Service</h2>
          <p className="locations__subtitle">
          Kunjungi iTech Service dan nikmati pengalaman service perangkat Apple yang nyaman dengan penanganan terbaik untuk setiap kebutuhan Anda.
          </p>
        </div>

        {/* Location filter */}
        <div className="locations__filters" data-aos="fade-up" data-aos-delay="200">
          <div className="locations__filters-head">
            <span className="section-eyebrow">Jaringan kami</span>
            <p className="locations__filters-hint">
              {projects.length} lokasi
              {activeCategory !== 'all' ? ` · ${activeCategory}` : ' di Jawa Timur'}
            </p>
          </div>
          <div className="locations__categories" role="tablist" aria-label="Filter kota">
            {uniqueCategories.map((category) => (
              <button
                key={category}
                type="button"
                role="tab"
                aria-selected={activeCategory === category}
                className={`locations__category-btn ${activeCategory === category ? 'locations__category-btn--active' : ''}`}
                onClick={() => filterProjectsHandler(category)}
              >
                <FontAwesomeIcon icon={faMapMarkerAlt} className="locations__category-icon" aria-hidden />
                <span>{category === 'all' ? 'Semua' : category}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Locations Grid */}
        <div className="locations__grid" data-aos="fade-up" data-aos-delay="300">
          {projects.map((location, index) => (
            <Card 
              key={location.id} 
              variant="portfolio"
              interactive={true}
              className="locations__card"
              data-aos="fade-up"
              data-aos-delay={400 + (index * 100)}
            >
              <div className="locations__media">
                <CardImage
                  src={location.image}
                  alt={`Lokasi iTech Service di ${location.title}`}
                  aspectRatio="16/10"
                  className="locations__image"
                />
                <span className="locations__image-tag">
                  <FontAwesomeIcon icon={faMapMarkerAlt} aria-hidden />
                  {location.category}
                </span>
              </div>

              <CardBody className="locations__content">
                <CardTitle className="locations__card-title">
                  iTech Service {location.title}
                </CardTitle>

                <CardDescription className="locations__address">
                  {location.total}
                </CardDescription>
              </CardBody>

              <CardFooter className="locations__footer">
                <button
                  type="button"
                  className="btn btn-primary locations__directions-btn"
                  onClick={() => handleDirectionsClick(location.monit)}
                  aria-label={`Petunjuk arah ke iTech Service ${location.title}`}
                >
                  <FontAwesomeIcon icon={faRoute} aria-hidden />
                  <span>Petunjuk Arah</span>
                </button>
              </CardFooter>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="locations__cta" data-aos="fade-up" data-aos-delay="600">
          <h3 className="locations__cta-title">Belum Menemukan Lokasi Terdekat?</h3>
          <p className="locations__cta-description">
          Kami terus memperluas jangkauan layanan untuk memberikan kemudahan service perangkat Apple di berbagai wilayah. Hubungi kami untuk informasi layanan dan ketersediaan area service.
          </p>
          <button 
            className="btn btn-primary locations__cta-button"
            onClick={() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            aria-label="Hubungi kami tentang lokasi layanan"
          >
            Hubungi Kami
          </button>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
